/* Wax / Claude — Ministry of Sound pre-launch interactions — 2026-10-20 */
/* Ministry of Sound pre-launch sections: sign-up, soundsystem gallery, enquiry form. */
(function () {
  function init(scope) {
    scope.querySelectorAll('form[data-mos-signup]:not([data-ready])').forEach(function (form) {
      form.dataset.ready = '1';
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = form.querySelector('input[type=email]');
        var msg = form.querySelector('.mos-msg');
        var btn = form.querySelector('button[type=submit]');
        var email = (input.value || '').trim();
        var key = form.dataset.key, list = form.dataset.list;
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { msg.dataset.state = 'err'; msg.textContent = 'Enter a valid email address.'; input.focus(); return; }
        if (!key || !list) { msg.dataset.state = 'err'; msg.textContent = 'Sign-up is not connected yet.'; return; }
        btn.disabled = true; msg.dataset.state = ''; msg.textContent = 'Signing you up...';
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(key), {
          method: 'POST',
          headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-10-15' },
          body: JSON.stringify({ data: { type: 'subscription', attributes: {
            custom_source: form.dataset.source || 'MOS pre-launch page',
            profile: { data: { type: 'profile', attributes: {
              email: email,
              properties: { 'MOS 35 interest': true },
            } } }
          }, relationships: { list: { data: { type: 'list', id: list } } } } })
        }).then(function (r) {
          if (!r.ok) throw new Error(r.status);
          form.classList.add('is-done'); msg.dataset.state = 'ok'; msg.textContent = form.dataset.ok || 'Thanks, you are on the list.';
        }).catch(function () {
          msg.dataset.state = 'err'; msg.textContent = 'That did not go through. Check your email address and try again.';
        }).finally(function () { btn.disabled = false; });
      });
    });

    scope.querySelectorAll('[data-mos-stage]:not([data-ready])').forEach(function (stage) {
      stage.dataset.ready = '1';
      var main = stage.querySelector('.mos-stage__main img');
      stage.querySelectorAll('[data-mos-thumb]').forEach(function (t) {
        t.addEventListener('click', function () {
          if (!main) return;
          stage.querySelectorAll('[data-mos-thumb]').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
          t.setAttribute('aria-pressed', 'true');
          main.style.opacity = '0.2';
          var img = new Image();
          img.onload = function () { main.removeAttribute('srcset'); main.src = t.dataset.src; main.style.opacity = '1'; };
          img.src = t.dataset.src;
        });
      });
    });

    var enq = document.getElementById('mos-enquiry-form');
    if (enq && !enq.dataset.ready) {
      enq.dataset.ready = '1';
      var posted = enq.querySelector('.mos-ok, .mos-err') || /contact_posted/.test(location.search);
      if (!posted) enq.hidden = true;
      var open = function (focus) {
        enq.hidden = false;
        document.querySelectorAll('[data-mos-enquire]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
        if (focus) { var f = enq.querySelector('input:not([type=hidden])'); if (f) f.focus({ preventScroll: true }); }
      };
      document.querySelectorAll('[data-mos-enquire]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (enq.hidden) { open(true); enq.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }
          else { enq.hidden = true; b.setAttribute('aria-expanded', 'false'); }
        });
      });
      document.querySelectorAll('[data-mos-open-enquiry]').forEach(function (a) { a.addEventListener('click', function () { open(false); }); });
      if (location.hash === '#mos-enquiry-form') open(false);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();